import LoggerService from "@bfx/logger";
import { ResizeObserverScheduler } from "./resize-observer-scheduler";

const logger = LoggerService.for(__dirname);

export class ResizeObserverSchedulerTarget extends ResizeObserverScheduler {
  constructor(
    callback: (
      entries: Array<ResizeObserverEntry>,
      observer: ResizeObserver,
    ) => Promise<void> | void,
    protected getTargetElement: () => any | null,
    protected source: string,
  ) {
    const targetElement = getTargetElement();

    super(callback, source);

    if (targetElement != null) {
      this.observe(targetElement);
    } else {
      logger.out.error(`${this.constructor.name} null targetElement`);
      this.complete();
    }
  }

  protected override scheduleCallback(entries: ResizeObserverEntry[], observer): void {
    const element = this.getTargetElement();
    if (!Array.isArray(entries) || entries.length !== 1) {
      logger.out.error(
        `${this.constructor.name}: bailing out of scheduleCallback() for ${this.source} due to no entries %O`,
        entries,
      );
      return;
    } else if (!element || entries[0].target !== element) {
      logger.out.error(
        `${this.constructor.name} scheduleCallback() for ${this.source} bailing out of callback due to mismatch %O`,
        entries,
      );
      return;
    }

    setTimeout(() => {
      this.scheduleSubject.next({ entries, observer });
    }, 0);
  }
}
